import { render, staticRenderFns } from "./PayrollPivotDetail.vue?vue&type=template&id=93c711bc"
import script from "./PayrollPivotDetail.vue?vue&type=script&lang=js"
export * from "./PayrollPivotDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports